import {
  DimmerStatus,
  SceneActionListItemDTO,
  SceneLightState,
  SceneObjectType,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import ActionLight from './ActionLight/ActionLight.vue';
import ActionLightDimmer from './ActionLightDimmer/ActionLightDimmer.vue';
import ActionWaitingTime from './ActionWaitingTime/ActionWaitingTime.vue';
import ActionThermostat from './ActionThermostat/ActionThermostat.vue';
import ActionShutter from './ActionShutter/ActionShutter.vue';
import ActionBlind from './ActionBlind/ActionBlind.vue';
import ActionSocket from './ActionSocket/ActionSocket.vue';
import ActionLock from './ActionLock/ActionLock.vue';

@Options({
  name: 'DialogAddAction',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    actionToAdd: {
      type: [Object as PropType<SceneActionListItemDTO>, null],
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
    isDialogVisible: function (newValue) {
      this.$emit('update:isVisible', newValue);
    },
  },
  components: {
    ActionLight,
    ActionLightDimmer,
    ActionThermostat,
    ActionShutter,
    ActionWaitingTime,
    ActionBlind,
    ActionSocket,
    ActionLock,
  },
  emits: ['confirm', 'update:isVisible'],
})
export default class DialogAddAction extends Vue {
  SceneObjectType = SceneObjectType;
  SceneLightState = SceneLightState;
  DimmerStatus = DimmerStatus;

  isVisible!: boolean;
  actionToAdd!: SceneActionListItemDTO;
  isDialogVisible = false;
  confirmDisabled = false;

  get headerName() {
    return this.actionToAdd?.name;
  }

  get actionComponent() {
    switch (this.actionToAdd.sceneObjectType) {
      case SceneObjectType.Light:
      case SceneObjectType.GeneralCommandsLights:
      case SceneObjectType.GroupOfLights: {
        return 'ActionLight';
      }
      case SceneObjectType.Dimmer: {
        return 'ActionLightDimmer';
      }
      case SceneObjectType.Shutter:
      case SceneObjectType.GeneralCommandsShutters:
      case SceneObjectType.GroupOfShutters: {
        return 'ActionShutter';
      }
      case SceneObjectType.Thermostat: {
        return 'ActionThermostat';
      }
      case SceneObjectType.Lock: {
        return 'ActionLock';
      }
      case SceneObjectType.DateTime: {
        return 'ActionWaitingTime';
      }
      case SceneObjectType.TowelWarmer: {
        return 'ActionLight'; //TODO: real component
      }
      case SceneObjectType.Fancoil: {
        return 'ActionLight'; //TODO: real component
      }
      case SceneObjectType.Blind: {
        return 'ActionBlind';
      }
      case SceneObjectType.Socket: {
        return 'ActionSocket';
      }
      default:
        return '';
    }
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  doHideDialog() {
    this.isDialogVisible = false;
  }

  updateConfirmDisabled(newValue: boolean) {
    this.confirmDisabled = newValue;
  }

  doConfirm() {
    this.$emit('confirm');
    this.doHideDialog();
  }
}
